import { Text, View, StyleSheet, Font } from '@react-pdf/renderer';
import { Fragment, useContext } from 'react';
import { GlobalContext } from '../../context/Provider';
import { dataType } from '../../pages/order/orderInterface';

Font.register({
    family: 'bold',
    src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-bold-webfont.ttf",
    fontWeight: 'bold'
});

Font.register({
    family: 'italic',
    src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-mediumitalic-webfont.ttf",
});

Font.register({
    family: 'italic-regular',
    src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-italic-webfont.ttf",
});

Font.register({
    family: 'medium',
    src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-medium-webfont.ttf",
});

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
    },
    w_100: {
        width: '100%',
    },
});

const InvoiceTable = ({ dataHolder }: dataType) => {

    const { authState, language_data } = useContext(GlobalContext);

    // helper translation function
    const t = (key: string, fallback: string) =>
        (language_data?.[authState?.lang] as any)?.[key] || fallback;
    return (
        <Fragment>

            {/* Table Heading */}
            <View style={styles.container}>

                <View style={{ width: '18%' }}>
                    <Text style={{ fontFamily: 'bold' }}>
                        {t('common_product', 'Product')}
                    </Text>
                </View>

                <View style={{ width: '27%' }}>
                    <Text style={{ fontFamily: 'bold' }}>
                        {t('common_title', 'Title')}
                    </Text>
                </View>

                <View style={{ width: '10%' }}>
                    <Text style={{ fontFamily: 'bold' }}>
                        {t('common_qty', 'Qty')}
                    </Text>
                </View>

                <View style={{ width: '10%' }}>
                    <Text style={{ fontFamily: 'bold' }}>
                        {t('common_gross', 'Gross')}
                    </Text>
                    <Text style={{ fontFamily: 'bold' }}>
                        {t('common_amount', 'Amount')} $
                    </Text>
                </View>

                <View style={{ width: '10%' }}>
                    <Text style={{ fontFamily: 'bold' }}>
                        {t('common_discount', 'Discount')}
                    </Text>
                    <Text style={{ fontFamily: 'bold' }}>
                        /{t('common_coupons', 'Coupons')} $
                    </Text>
                </View>

                <View style={{ width: '10%' }}>
                    <Text style={{ fontFamily: 'bold' }}>
                        {t('common_taxable', 'Taxable')}
                    </Text>
                    <Text style={{ fontFamily: 'bold' }}>
                        {t('common_value', 'Value')} $
                    </Text>
                </View>

                <View style={{ width: '10%' }}>
                    <Text style={{ fontFamily: 'bold' }}>
                        {t('common_tax', 'Tax')} $
                    </Text>
                </View>

                <View style={{ width: '5%' }}>
                    <Text style={{ fontFamily: 'bold', textAlign: 'right' }}>
                        {t('common_total', 'Total')}
                    </Text>
                    <Text style={{ fontFamily: 'bold', textAlign: 'right' }}>
                        {t('common_earning', 'Earning')} $
                    </Text>
                </View>

            </View>

            <View style={{ borderBottom: '1px solid #000', margin: '10px 0' }} />

            {/* Order Price */}
            <View style={styles.container}>

                <View style={{ width: '18%' }}>
                    <Text>
                        {dataHolder?.product?.subcategory?.name ||
                            dataHolder?.product_id?.subcategory?.name ||
                            t('common_not_available', 'N/A')}
                    </Text>
                    <Text>
                        {dataHolder?.product?.prod_id ||
                            dataHolder?.product_id?.prod_id ||
                            t('common_not_available', 'N/A')}
                    </Text>
                </View>

                <View style={{ width: '27%' }}>
                    <Text style={{ fontFamily: 'bold' }}>
                        {dataHolder?.product?.name ||
                            dataHolder?.product_id?.name ||
                            t('common_not_available', 'N/A')}
                    </Text>

                    {(dataHolder?.product?.services || dataHolder?.product_id?.services)?.map((res: any) => (
                        <Text key={res?._id}>{res?.content}</Text>
                    ))}

                    <View style={[styles.container, { marginTop: 4 }]}>
                        <Text style={{ fontFamily: 'bold', marginRight: 3 }}>
                            {t('common_tax', 'Tax')}:
                        </Text>
                        <Text>
                            {dataHolder?.tax_percantage
                                ? `${dataHolder.tax_percantage}%`
                                : t('common_appicable', 'Applicable')}
                        </Text>
                    </View>
                </View>

                <View style={{ width: '10%' }}>
                    <Text>
                        {dataHolder?.quantity ||
                            t('common_out_of_stock', 'Out of Stock')}
                    </Text>
                </View>

                <View style={{ width: '10%' }}>
                    <Text>{dataHolder?.price || '0'}</Text>
                </View>

                <View style={{ width: '10%' }}>
                    <Text>{dataHolder?.coupon_discount ? -dataHolder.coupon_discount : '0'}</Text>
                </View>

                <View style={{ width: '10%' }}>
                    <Text>
                        {((dataHolder?.price || 0) - (dataHolder?.coupon_discount || 0))?.toFixed(2)}
                    </Text>
                </View>

                <View style={{ width: '10%' }}>
                    <Text>{dataHolder?.tax_amount?.toFixed(2)}</Text>
                </View>

                <View style={{ width: '5%' }}>
                    <Text style={{ textAlign: 'right' }}>
                        {dataHolder?.your_earning?.toFixed(2) || '0'}
                    </Text>
                </View>

            </View>

            {/* Shipping Charges */}
            <View style={[styles.container, { margin: '10px 0' }]}>

                <View style={{ width: '18%' }} />

                <View style={{ width: '27%' }}>
                    <Text style={{ fontFamily: 'bold' }}>
                        {t('common_shopping', 'Shipping')} {t('common_and', '&')} {t('common_convenience', 'Convenience')} {t('common_charges', 'Charges')}
                    </Text>
                </View>

                <View style={{ width: '10%' }}>
                    <Text>{dataHolder?.quantity || t('common_not_available', 'N/A')}</Text>
                </View>

                <View style={{ width: '10%' }}>
                    <Text>{dataHolder?.delivery_price || '0'}</Text>
                </View>

            </View>

            <View style={{ borderBottom: '1px solid #000', margin: '5px 0 10px' }} />

            {/* Total Row */}
            <View style={styles.container}>

                <Text style={{ width: '18%' }} />

                <Text style={{ width: '27%', fontFamily: 'bold' }}>
                    {t('common_total', 'Total')}
                </Text>

                <Text style={{ width: '10%', fontFamily: 'bold' }}>
                    {dataHolder?.quantity || t('common_not_available', 'N/A')}
                </Text>

                <Text style={{ width: '10%', fontFamily: 'bold' }}>
                    {(dataHolder?.price || 0) + (dataHolder?.delivery_price || 0)}
                </Text>

                <Text style={{ width: '10%', fontFamily: 'bold' }}>
                    {dataHolder?.coupon_discount ? -dataHolder.coupon_discount : '0'}
                </Text>

                <Text style={{ width: '10%', fontFamily: 'bold' }}>
                    {((dataHolder?.price || 0) - (dataHolder?.coupon_discount || 0))?.toFixed(2)}
                </Text>

                <Text style={{ width: '10%', fontFamily: 'bold' }}>
                    {dataHolder?.tax_amount?.toFixed(2)}
                </Text>

                <Text style={{ width: '5%', fontFamily: 'bold', textAlign: 'right' }}>
                    {Number(dataHolder?.your_earning).toFixed(2)}
                </Text>

            </View>

            <View style={{ borderBottom: '1px solid #000', margin: '12px 0' }} />

            {/* Grand Totals */}
            <View style={styles.container}>

                <View style={{ width: "75%" }} />

                <View style={{ width: "25%" }}>

                    <View style={styles.container}>
                        <Text style={{ fontSize: 10, width: '50%', fontFamily: 'medium' }}>
                            {t('common_admin', 'Admin')} {t('common_commission', 'Commission')}
                        </Text>
                        <Text style={{ fontSize: 10, width: '50%', textAlign: 'right', fontFamily: 'bold' }}>
                            $ {Number(dataHolder?.admin_commision).toFixed(2)}
                        </Text>
                    </View>

                    <View style={styles.container}>
                        <Text style={{ fontSize: 10, width: '50%', fontFamily: 'medium' }}>
                            {t('common_grand', 'Grand')} {t('common_total', 'Total')} {t('common_earning', 'Earnings')}
                        </Text>
                        <Text style={{ fontSize: 10, width: '50%', textAlign: 'right', fontFamily: 'bold' }}>
                            $ {Number(dataHolder?.your_earning).toFixed(2)}
                        </Text>
                    </View>

                    <View style={styles.container}>
                        <Text style={{ fontSize: 10, width: '50%', fontFamily: 'medium' }}>
                            {t('common_grand', 'Grand')} {t('common_total', 'Total')} {t('common_price', 'Price')}
                        </Text>
                        <Text style={{ fontSize: 10, width: '50%', textAlign: 'right', fontFamily: 'bold' }}>
                            $ {Number(dataHolder?.total_price).toFixed(2)}
                        </Text>
                    </View>

                </View>

            </View>

            <View style={styles.container}>
                <Text style={[styles.w_100, { textAlign: 'right', fontFamily: 'medium', marginTop: 5 }]}>
                    {dataHolder?.seller_id?.company || t('common_not_available', 'N/A')}
                </Text>
            </View>

        </Fragment>
    );
};

export default InvoiceTable;